/**
 * cart-checkout-gate.js
 *
 * Blocks checkout (native + PayPal/express) until every main cart item
 * that has a delivery-picker (.cart-upsell) has one of its radios selected.
 * Shows a friendly hint and scroll-highlights the missing item on click.
 */
(function () {
  const MSG_ID = 'cart-delivery-gate-msg';
  const HIGHLIGHT_CLASS = 'cart-item--gate-highlight';
  const GATE_MESSAGE = 'Bitte wähle für jedes Produkt eine Versandart aus, um fortzufahren.';

  function getMainItems() {
    return Array.from(document.querySelectorAll('tr.cart-item'))
      .filter((el) => !el.dataset.linkedTo);
  }

  function findMissingItems() {
    return getMainItems().filter((item) => {
      const upsell = item.querySelector('.cart-upsell');
      if (!upsell) return false;
      // "Abgabe" option inside a collapsed <details> also counts as available
      const radios = item.querySelectorAll('.cart-upsell__radio');
      if (!radios.length) return false;
      const anyChecked = Array.from(radios).some((r) => r.checked);
      return !anyChecked;
    });
  }

  function checkoutButtons() {
    return Array.from(document.querySelectorAll(
      '[name="checkout"], .cart__checkout-button'
    ));
  }

  function dynamicCheckoutWrapper() {
    return document.querySelector('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
  }

  function setGateState(blocked) {
    checkoutButtons().forEach((btn) => {
      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.gateBlocked = '1';
      } else {
        if (btn.dataset.gateBlocked) {
          btn.removeAttribute('disabled');
          btn.removeAttribute('aria-disabled');
          delete btn.dataset.gateBlocked;
        }
      }
    });

    const dynamic = dynamicCheckoutWrapper();
    if (dynamic) {
      dynamic.style.opacity = blocked ? '0.45' : '';
      dynamic.style.pointerEvents = blocked ? 'none' : '';
      dynamic.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }

    let msg = document.getElementById(MSG_ID);
    if (blocked) {
      if (!msg) {
        msg = document.createElement('div');
        msg.id = MSG_ID;
        msg.className = 'cart-delivery-gate-msg';
        msg.textContent = GATE_MESSAGE;
      }
      // Insert it just above the first checkout button's parent block
      const ctas = document.querySelector('.cart__ctas');
      if (ctas && msg.parentElement !== ctas) {
        ctas.insertBefore(msg, ctas.firstChild);
      }
    } else if (msg && msg.parentElement) {
      msg.parentElement.removeChild(msg);
    }
  }

  function validate() {
    const missing = findMissingItems();
    setGateState(missing.length > 0);
    return missing;
  }

  // Intercept clicks on a blocked button — scroll to missing item and pulse-highlight
  function handleInterceptClick(event) {
    const btn = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], .cart__checkout-button, .shopify-payment-button__button, .additional-checkout-buttons button, .additional-checkout-buttons [role="button"]')
      : null;
    if (!btn) return;
    const missing = findMissingItems();
    if (!missing.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const first = missing[0];
    first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    first.classList.add(HIGHLIGHT_CLASS);
    setTimeout(() => first.classList.remove(HIGHLIGHT_CLASS), 1800);
  }

  function onRadioChange(event) {
    if (!event.target || !event.target.classList) return;
    if (!event.target.classList.contains('cart-upsell__radio')) return;
    // Server-side update happens async in cart-drawer.js handleRadioChange;
    // still, reflect the check state immediately in gate UI
    setTimeout(validate, 50);
  }

  function wireUp() {
    validate();
  }

  // Initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireUp);
  } else {
    wireUp();
  }
  // Re-validate after cart updates (section re-renders wipe listeners on children but we use delegated capture)
  document.addEventListener('cart:updated', () => setTimeout(validate, 50));
  // Delegated change handler (survives re-renders)
  document.addEventListener('change', onRadioChange, true);
  // Capture-phase click interceptor (runs before native submit)
  document.addEventListener('click', handleInterceptClick, true);
})();
